import { combineReducers } from 'redux';

import data from './data';
import dealersModes from './dealersModes';
import ui from './ui';

/**
 * @typedef {{
 *  data: import("./data").StepDataEntity,
 *  dealersModes: import("./dealersModes").StepsDealerModeReducer,
 *  ui: import('./ui').StepUiReducer,
 * }} StepReducer
 */

export default combineReducers({
  data,
  dealersModes,
  ui,
});
